import { render } from "./MobileMenuParentGroup.vue?vue&type=template&id=7e2a1c06"
import script from "./MobileMenuParentGroup.vue?vue&type=script&lang=js"
export * from "./MobileMenuParentGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__